import { SelectOptionType } from "types/select/SelectOptionType";

export function criarSelectOptions<T>(value: any, label: string): SelectOptionType<T> {
  return { value, label };
}
